import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";
import { aeChoices } from "../config-generics/aeKao";
import { signatureConfig } from "../config-generics/signature";

export const confirmationConfig: PageConfig[] = [
  {
    name: "confirmation",
    title: "Kī Taurangi - Declaration",
    questions: [
      {
        type: "radiogroup",
        name: "correct",
        title:
          "I/we confirm that the information provided is true and correct.",
        choices: aeChoices,
        isRequired: true,
      },
      signatureConfig[0].questions[0],
    ],
  },
];
